import { StyledFileUploadManyField } from 'modules/components/layer03';
import { appFormUtil } from 'modules/common';
import React from 'react';



export type UploadAttachmentsFieldProps<T extends object, K extends keyof T = keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: K;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends {}>(props: UploadAttachmentsFieldProps<T>) => {
  const fieldProps = props.form.genFieldProps(props.fieldName);
  return (
    <StyledFileUploadManyField.FC
      form={props.form}
      formFieldPropertyName={props.fieldName}
      required={fieldProps.required}
      formLabel='Upload a File'
    />
  );
};
